<template>
    <div>
        <img
            src="https://upload.wikimedia.org/wikipedia/en/thumb/7/7a/Gemological_Institute_of_America_logo.svg/2560px-Gemological_Institute_of_America_logo.svg.png"
            alt="GIA logo"
            style="height: 20px;"
        />

        <p
            class="gia-text"
            v-html="
                $t('components.gia', {
                    url: certificateUrl
                })
            "
        ></p>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";
import useStore from "@/composables/useStore";
import {useI18n} from "vue-i18n";
import useDiamondProperties from "@/composables/useDiamondProperties";

export default defineComponent({
    name: "SelectedDiamondGiaCertificate",
    setup() {
        const store = useStore();
        const selectedDiamond = computed(
            () => store.state.userSelection.diamond
        );

        const {certificateUrl} = useDiamondProperties(selectedDiamond);

        return {
            ...useI18n(),
            selectedDiamond,
            certificateUrl
        };
    }
});
</script>

<style>
.gia-text {
    margin-top: 13px;
    margin-bottom: 13px;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.gia-text a,
.gia-text a:visited {
    color: inherit;
}
</style>
